import { render, staticRenderFns } from "./PasswortAuge.vue?vue&type=template&id=3f217eda"
import script from "./PasswortAuge.vue?vue&type=script&lang=js"
export * from "./PasswortAuge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports